<script>
import Vue from 'vue'

export default Vue.extend({
    data() {
        return {
            selected: null,
            options: [],
        }
    },
    props: ['field', 'resourceInstance', 'value'],
    methods: {
        setValue(newVal) {
            this.resourceInstance.attributes[this.field.attribute] = newVal
        },
    },
    watch: {
        selected: function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.setValue(newVal)
            }
        },
    },
    mounted() {
        this.options = this.field.options
        if (this.value) {
            this.selected = this.value
            this.setValue(this.value)
        }
    },
})
</script>

<template>
    <div>
        <b-form-select v-model="selected" :options="options"></b-form-select>
    </div>
</template>

<style scoped></style>
